
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return require("private-next-pages/features.tsx");
      }
    ]);
  